module.exports = __webpack_public_path__ + "img/tutorial_BG_auto.ea470478.jpg";